// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileRoomlistReloadMessage{background-color:#fbe0e0;color:#c00;display:inline-block;line-height:1.4em;margin:5px}.MobileRoomlistReloadMessage a{cursor:pointer}.MobileRoomlistReloadMessage a:hover{text-decoration:underline}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
